import { getDefaultStepIndex } from '../Utils/Steps';
import { getPostStatus } from '../Utils/Post';

const postDatesStatus = (post: any) => {
  if (post.included.steps) {
    const defaultStepIndex = getDefaultStepIndex(post);

    return post.included.steps[defaultStepIndex]?.dates_status;
  }

  return getPostStatus(post);
};

export default postDatesStatus;
